import { render, staticRenderFns } from "./EaVgasGameTile.vue?vue&type=template&id=f8048b98&lang=pug&"
import script from "./EaVgasGameTile.vue?vue&type=script&lang=js&"
export * from "./EaVgasGameTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports